"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_select_1 = __importDefault(require("react-select"));
const apiUtils_1 = require("../../../../util/apiUtils");
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const theme_1 = require("../../../../theme");
const common_styled_components_1 = require("../../../common-styled-components");
const DateInput_1 = require("../../../generic/DateInput");
const TextInput_1 = require("../../../generic/TextInput");
const common_1 = require("./common");
const optionUtil_1 = require("../../../../util/compliance/optionUtil");
const verifaviaModeOptions = [
    { label: "Integration", value: "integration" },
    { label: "Debug", value: "debug" },
];
const clientOptions = [
    { label: "Carisbrooke", value: "carisbrooke" },
    { label: "Nescos", value: "nescos" },
    { label: "ASP", value: "asp" },
    { label: "Ansei", value: "ansei" },
];
const endpointOptions = [
    { label: "Ship List", value: "ship_list" },
    { label: "Commercial Voyages", value: "commercial_voyages" },
    { label: "Voyages", value: "voyages" },
];
const VerifaviaIntegrationTool = ({ fleetOptions, poolOptions, }) => {
    const [mode, setMode] = (0, react_1.useState)({
        label: "Integration",
        value: "integration",
    });
    const [imoNumber, setImoNumber] = (0, react_1.useState)("");
    const [startDate, setStartDate] = (0, react_1.useState)("");
    const [endDate, setEndDate] = (0, react_1.useState)("");
    const [client, setClient] = (0, react_1.useState)(clientOptions[0]);
    const [endpoint, setEndpoint] = (0, react_1.useState)({
        label: "Ship List",
        value: "ship_list",
    });
    const emptyFleet = (0, optionUtil_1.getEmptyOption)("fleet");
    const fleetSelectOptions = [emptyFleet].concat(fleetOptions);
    const emptyPool = (0, optionUtil_1.getEmptyOption)("pool");
    const poolSelectOptions = [emptyPool].concat(poolOptions);
    const [fleetId, setFleetId] = (0, react_1.useState)(null);
    const [poolId, setPoolId] = (0, react_1.useState)(null);
    const [verifaviaApiResponse, setApiUrl] = (0, useFetch_1.default)();
    const fetchVerifaviaData = () => {
        if (!imoNumber) {
            alert("IMO number is required");
            return;
        }
        if (mode.value === "integration" &&
            endpoint.value !== "commercial_voyages") {
            alert("Only Commercial Voyages endpoint supports integration mode");
            return;
        }
        const params = new URLSearchParams({
            imonumber: imoNumber,
            client: client.value,
            _t: Date.now().toString(),
        });
        if (startDate)
            params.append("startDate", startDate);
        if (endDate)
            params.append("endDate", endDate);
        if (mode.value === "debug")
            params.append("debug", "1");
        let baseUrl = "";
        if (endpoint.value === "ship_list") {
            baseUrl = "admin/verifavia_ship_list.json";
        }
        else if (endpoint.value === "commercial_voyages") {
            baseUrl = "admin/verifavia_commercial_voyages.json";
            if (mode.value === "integration") {
                if (fleetId !== null)
                    params.append("fleet_id", String(fleetId));
                if (poolId !== null)
                    params.append("pool_id", String(poolId));
            }
        }
        else if (endpoint.value === "voyages") {
            baseUrl = "admin/verifavia_voyages.json";
        }
        const url = `${baseUrl}?${params.toString()}`;
        console.log("Fetching URL:", url);
        setApiUrl(url);
    };
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallTitle, { children: "Verifavia API Integration" }), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "Mode", children: (0, jsx_runtime_1.jsx)(react_select_1.default, { value: mode, onChange: (value) => setMode(value), options: verifaviaModeOptions }) }), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "Endpoint", children: (0, jsx_runtime_1.jsx)(react_select_1.default, { value: endpoint, onChange: (value) => setEndpoint(value), options: endpointOptions }) }), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "Client", children: (0, jsx_runtime_1.jsx)(react_select_1.default, { value: client, onChange: (value) => value && setClient(value), options: clientOptions }) }), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "IMO Number", children: (0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { value: imoNumber, onChange: (value) => setImoNumber(value), placeholder: "e.g., 9123456", disableDebounce: true }) }), mode.value === "integration" && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "Fleet", children: (0, jsx_runtime_1.jsx)(react_select_1.default, { options: fleetSelectOptions, onChange: (value) => setFleetId(value?.value ?? null), value: fleetSelectOptions.find((option) => option.value === fleetId) ??
                                emptyFleet, isOptionSelected: (option) => option.value === fleetId }) }), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "Pool", children: (0, jsx_runtime_1.jsx)(react_select_1.default, { options: poolSelectOptions, onChange: (value) => setPoolId(value?.value ?? null), value: poolSelectOptions.find((option) => option.value === poolId) ??
                                emptyPool, isOptionSelected: (option) => option.value === poolId }) })] })), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "Start Date (optional)", children: (0, jsx_runtime_1.jsx)(DateInput_1.DateInput, { value: startDate, onChange: (value) => setStartDate(value) }) }), (0, jsx_runtime_1.jsx)(common_1.FieldContainer, { label: "End Date (optional)", children: (0, jsx_runtime_1.jsx)(DateInput_1.DateInput, { value: endDate, onChange: (value) => setEndDate(value) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: fetchVerifaviaData, children: mode.value === "integration" ? "Fetch and Store Data" : "Fetch Data" }), verifaviaApiResponse.status === apiUtils_1.LoaderStatus.Loading && ((0, jsx_runtime_1.jsx)("div", { children: "Loading..." })), verifaviaApiResponse.status === apiUtils_1.LoaderStatus.Error && ((0, jsx_runtime_1.jsxs)("div", { style: { color: theme_1.theme.colors.red }, children: ["Error: ", String(verifaviaApiResponse.error)] })), (0, jsx_runtime_1.jsx)(common_1.ResultMessage, { response: verifaviaApiResponse, mode: mode.value })] }));
};
exports.default = VerifaviaIntegrationTool;
